import Component from '../../../../../pages/vpp/features/accessibility-texts/text-jump-to-purchase-section.desktop';

export default Component;
